import React from 'react';

import { Textarea } from '@buildoutinc/blueprint-react/ui/Textarea';
import { ButtonGroup } from '@buildoutinc/blueprint-react/ui/ButtonGroup';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';

import PanelFooter from './panel_footer';
import { CALL_RESULTS } from './config';

interface Props {
  callResult?: string;
  dateLabel: string;
  placeholder: string;
  saving: boolean;
  value: string;
  onCallResultChange: (result: string) => void;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export default function CallPanel({
  callResult,
  dateLabel,
  placeholder,
  saving,
  value,
  onCallResultChange,
  onChange,
  onSubmit,
}: Props) {
  return (
    <div className="d-flex flex-column gap-3">
      <Textarea
        placeholder={placeholder}
        rows={4}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
      />

      <ButtonGroup>
        {CALL_RESULTS.map((result) => {
          const selected = callResult === result.key;
          return (
            <Button
              icon={selected ? faCheck : null}
              key={result.key}
              variant={selected ? 'primary' : 'outline'}
              onClick={() => onCallResultChange(selected ? '' : result.key)}
            >
              {result.label}
            </Button>
          );
        })}
      </ButtonGroup>

      <PanelFooter
        buttonLabel="Log Call"
        dateLabel={dateLabel}
        disabled={!value.trim()}
        saving={saving}
        onSubmit={onSubmit}
      />
    </div>
  );
}
